module.exports = __webpack_public_path__ + "media/images/brussels_page/logo1-bd2106ec961914f98c1daa865b6eb7fa.svg";